import {
  BackofficeReorderPromoBody,
  BackofficeReorderPromoParams,
} from '@diamond/shared/types';
import { apiInstance } from '@diamond/shared/utils';

export const reorderPromo = async (
  token: string,
  params: BackofficeReorderPromoParams,
  body: BackofficeReorderPromoBody | undefined
) => {
  const url = `/backoffice/promo/${params.id}/reorder`;
  return apiInstance(token).patch(url, JSON.stringify(body));
};
